import InfoIcon from '@mui/icons-material/Info';
import { Dialog, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import '../css/InformacoesApp.css';
import Ambiente from '../util/Ambiente';
import InformacoesAppBackend from './InformacoesAppBackend.jsx';
import InformacoesLogFrontend from './InformacoesLogFrontend';
import ReactComponent from './ReactComponent';

const branchToAmbiente = {
    master: <span></span>,
    homologacao: 'homologação'
};

const ambiente = {
    development: 'desenvolvimento',
    homologation: 'homologacao',
    production: 'producao'
};

class InformacoesApp extends ReactComponent {
    info = {};
    infoBackend = [];
    infoBackendVisivel = false;
    open = false;

    exibicao = {
        nomeApp: this.observableProps.exibirNome,
        versaoApp: this.observableProps.exibirVersao,
        ambienteApp: this.observableProps.exibirAmbiente,
        backends: this.observableProps.exibirDependencias
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            info: observable,
            infoBackend: observable,
            infoBackendVisivel: observable,
            open: observable,
            exibicao: observable,
            abrirInfo: action,
            fecharInfo: action
        });
    }

    async componentDidMount() {
        try {
            let variaveisAmbiente = await this.healthCheckService.carregaVariaveisAmbiente();
            runInAction(() => {
                let branch = ambiente[process.env.REACT_APP_ENV];
                variaveisAmbiente.branch = branchToAmbiente[branch] || branch;
                this.info = variaveisAmbiente;
            });
        } catch (error) {
            console.error(`Falha na inicialização do componente InformacoesApp: ${ErrorUtil.getMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente InformacoesApp', { cause: error });
        }
    }

    abrirInfo = () => {
        this.open = true;
    };

    fecharInfo = () => {
        this.open = false;
    };

    render() {
        return (
            <div
                id="info-app"
                style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
                <IconButton
                    onClick={this.abrirInfo}
                    color="inherit"
                    aria-label="Informações sobre o sistema"
                    style={{ width: '40px' }}
                    size="large"
                >
                    <Tooltip title={'Informações sobre o sistema'}>
                        <InfoIcon />
                    </Tooltip>
                </IconButton>
                {this.open && (
                    <Dialog
                        open={this.open}
                        onClose={this.fecharInfo}
                        maxWidth="md"
                    >
                        <DialogTitle>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    {this.exibicao.nomeApp && (
                                        <Tooltip title="Nome da Aplicação">
                                            <Typography
                                                className="nomeApp"
                                                display="inline"
                                                fontSize="18px"
                                            >
                                                {this.info.nomeAplicacao}
                                            </Typography>
                                        </Tooltip>
                                    )}
                                    {this.exibicao.ambienteApp && (
                                        <Tooltip title="Ambiente">
                                            <Typography
                                                className={'branchApp'}
                                                display="inline"
                                                fontSize="18px"
                                            >
                                                {' ' + Ambiente.getDescricao()}
                                            </Typography>
                                        </Tooltip>
                                    )}
                                    {this.exibicao.versaoApp && (
                                        <Tooltip title="Versão / Build">
                                            <div>
                                                <Typography
                                                    className="versaoApp"
                                                    display="inline"
                                                    fontWeight="bold"
                                                >
                                                    Versão (front-end):{' '}
                                                </Typography>
                                                <Typography display="inline">{this.info.versaoAplicacao}</Typography>
                                                <Typography
                                                    display="inline"
                                                    fontWeight="bold"
                                                >
                                                    {' ' + this.info.buildAplicacao}
                                                </Typography>
                                            </div>
                                        </Tooltip>
                                    )}
                                </div>
                                <div style={{ marginLeft: '20px' }}>
                                    <InformacoesLogFrontend />
                                </div>
                            </div>
                        </DialogTitle>
                        {this.exibicao.backends && <InformacoesAppBackend />}
                    </Dialog>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(InformacoesApp));
